import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  isFullScreen?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'main-content',
  props: {
    modifires: { type: [String, Array, Boolean] },
    isFullScreen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["main-content", { 'full-main-content': _ctx.isFullScreen }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})